export default {"src":"/_next/static/media/skillz_fairplay.36b824d9.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};